import React, { useEffect, useState, useRef } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { Button } from 'carbon-components-react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'

const ComponentQuestion = (props) => {
  const {
    tutorTalking,
    showCC,
    isHideSubtitle,
    onBotAnimeClick,
    onKnovoHelpSelected,
    onBotAnimeClose,
    Completed,
    isActive,
    isPractice,
    QuestionText,
    QuestionFontSize,
    FontStyle,
    Italic,
    Bold
  } = props

  return (
    <div className='embed-quest-container'>
      <p
        style={{
          padding: '1% 2%',
          fontSize:
            QuestionFontSize === 'SMALL'
              ? SMALL_DESKTOP
              : QuestionFontSize === 'LARGE'
              ? LARGE_DESKTOP
              : MEDIUM_DESKTOP,
          fontFamily: FontStyle,
          fontStyle: Italic === 'True' ? 'italic' : 'normal',
          fontWeight: Bold === 'True' ? 'bold' : 'normal',
          margin: '0px'
        }}
      >
        {QuestionText}
      </p>
    </div>
  )
}

export { ComponentQuestion }
